// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/invoice/v1/invoice.proto (package stailer_service_specification.invoice.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_field_description } = require("../../../description_support/v1/field_description_pb");
const { file_stailer_service_specification_invoice_qualified_invoice_v1_qualified_invoice } = require("../qualified_invoice/v1/qualified_invoice_pb");

/**
 * Describes the file stailer_service_specification/invoice/v1/invoice.proto.
 */
const file_stailer_service_specification_invoice_v1_invoice = /*@__PURE__*/
  fileDesc("CjZzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9pbnZvaWNlL3YxL2ludm9pY2UucHJvdG8SKHN0YWlsZXJfc2VydmljZV9zcGVjaWZpY2F0aW9uLmludm9pY2UudjEi2wEKB0ludm9pY2USzwEKEXF1YWxpZmllZF9pbnZvaWNlGAEgASgLMkwuc3RhaWxlcl9zZXJ2aWNlX3NwZWNpZmljYXRpb24uaW52b2ljZS5xdWFsaWZpZWRfaW52b2ljZS52MS5RdWFsaWZpZWRJbnZvaWNlQmaSghlC6YGp5qC86KuL5rGC5pu477yI44Kk44Oz44Oc44Kk44K577yJ5Yi25bqm44Gr6Zai44GZ44KL6Kit5a6a44Gn44GZqoIZGOmBqeagvOiri+axguabuOOBruioreWumriCGQFiBnByb3RvMw", [file_description_support_v1_field_description, file_stailer_service_specification_invoice_qualified_invoice_v1_qualified_invoice]);

/**
 * Describes the message stailer_service_specification.invoice.v1.Invoice.
 * Use `create(InvoiceSchema)` to create a new message.
 */
const InvoiceSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_invoice_v1_invoice, 0);


exports.file_stailer_service_specification_invoice_v1_invoice = file_stailer_service_specification_invoice_v1_invoice;
exports.InvoiceSchema = InvoiceSchema;
